<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active> ই অ’ ডি বি</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <h1 class="heading">বাণিজ্য কৰা সহজতা (ই অ’ ডি বি)</h1>
          </b-col>

       </b-row>
        <div class="paddingLeft30px">

          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->

      <div id="ConsDetails" class="" style="width:90vw;font-size:0.8rem">
          </br>
          <b-table :items="eodb" :fields="Eodbfields">
            <template v-slot:cell(name)="data">
             <span   v-html="data.value"></span>
            </template>
          </b-table>
      </div>
      <br>

    <br>

      </div>
  </b-container>

<br><br>
</b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
var consNo="";
var sdCode="";
var thColor = '#0288d1';
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },

  data() {
    return {

      Eodbfields: [
        { key: 'name', label: 'Particulars',thStyle: {width: '80vw'} }

      ],
      eodb : [],

      show:false

    }
  },
  mounted() {
    var temp = [];
    var obj={};
    this.show= true;
    var parent = this;
    axios.get(this.$urlCommon+ "/api/web/eodbReport")
    .then((response) => {
      parent.show= false;
      console.log(response.data);
      var data = response.data.EodbReport;
      temp.push({"name":"<a href='EodbePanjeeyanMutationReport'><strong> ePanjeeyan Mutation Report </strong></a>"});
      temp.push({"name":"<a href='EodbOwnershipChange'><strong> Ownership Change/ Change of Name </strong></a>"});
      temp.push({"name":"<a href='EodbNscReport'><strong> New Connection Report </strong></a>"});
     // temp.push({"name":"<a target='_blank' href='https://www.urjamitra.com/app/ScheduleOutage.html?sid=26&disid=36&CD=0'><strong>Outage Information</strong></a>"});
      temp.push({"name":"<a href='AS_EodbSaidiSaifiReport'><strong> EODB SAIDI SAIFI Report </strong></a>"});
       temp.push({"name":"<a href='EodbOutageDashboard'><strong> Dashboard for Power Outage </strong></a>"});
      temp.push({"name":"<a href='EodbThirdPartyVerification'><strong> Third-Party Consumer Verification </strong></a>"});
      // data.forEach(element => {
      // obj = {
      //    "name" : "<a href='"+parent.$urlCommon+"/" + element.file_location + "' target='_blank'><img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height='30px' width='30px' style='margin-left: -7px;' />" + element.name + "</a>",
      //    }
      //     temp.push(obj);
      // })

         parent.eodb = temp;
        // document.getElementById("date").innerHTML=data[0][5];
    })

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

/* edob style */
li{
  padding:0;
}
body{
    overflow-y:hidden;
  }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
}
/* edob style */


.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
